import { createSlice } from '@reduxjs/toolkit';

const initialState = [];
const pagesSlice = createSlice({
    name: 'application',
    initialState,
    reducers: {
        setPages: (state, { payload }) => {
            payload.forEach((page) => {
                state.push(page);
            });
        }
    },
});
// Action creators are generated for each case reducer function
pagesSlice.actions;
var pagesReducer = pagesSlice.reducer;

export { pagesReducer as default, pagesSlice };
//# sourceMappingURL=pagesSlice.js.map
